/* eslint-disable */
tinymce.addI18n('fr', {
  Redo: 'R\u00e9tablir',
  Undo: 'Annuler',
  Cut: 'Couper',
  Copy: 'Copier',
  Paste: 'Coller',
  'Select all': 'Tout s\u00e9lectionner',
  'New document': 'Nouveau document',
  Ok: 'Ok',
  Cancel: 'Annuler',
  'Visual aids': 'Aides visuelle',
  Bold: 'Gras',
  Italic: 'Italique',
  Underline: 'Soulign\u00e9',
  Strikethrough: 'Barr\u00e9',
  Superscript: 'Exposant',
  Subscript: 'Indice',
  'Clear formatting': 'Effacer la mise en forme',
  'Align left': 'Aligner \u00e0 gauche',
  'Align center': 'Centrer',
  'Align right': 'Aligner \u00e0 droite',
  Justify: 'Justifier',
  'Bullet list': 'Puces',
  'Numbered list': 'Num\u00e9rotation',
  'Decrease indent': 'Diminuer le retrait',
  'Increase indent': 'Augmenter le retrait',
  Close: 'Fermer',
  Formats: 'Formats',
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Votre navigateur ne supporte pas la copie directe. Merci d'utiliser les touches Ctrl+X/C/V.",
  Headers: 'Titres',
  'Header 1': 'Titre 1',
  'Header 2': 'Titre 2',
  'Header 3': 'Titre 3',
  'Header 4': 'Titre 4',
  'Header 5': 'Titre 5',
  'Header 6': 'Titre 6',
  Headings: 'En-t\u00eates',
  'Heading 1': 'En-t\u00eate 1',
  'Heading 2': 'En-t\u00eate 2',
  'Heading 3': 'En-t\u00eate 3',
  'Heading 4': 'En-t\u00eate 4',
  'Heading 5': 'En-t\u00eate 5',
  'Heading 6': 'En-t\u00eate 6',
  Preformatted: 'Pr\u00e9-formatt\u00e9',
  Div: 'Div',
  Pre: 'Pre',
  Code: 'Code',
  Paragraph: 'Paragraphe',
  Blockquote: 'Citation',
  Inline: 'En ligne',
  Blocks: 'Blocs',
  'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.':
    'Le presse-papiers est maintenant en mode "texte plein". Les contenus seront coll\u00e9s sans retenir les formatages jusqu\'\u00e0 ce que vous d\u00e9sactiviez cette option.',
  'Font Family': 'Police',
  'Font Sizes': 'Taille de police',
  Class: 'Classe',
  'Browse for an image': 'Parcourir pour s\u00e9lectionner une image',
  OR: 'OU',
  'Drop an image here': 'Glisser une image ici',
  Upload: 'D\u00e9poser',
  Block: 'Bloquer',
  Align: 'Aligner',
  Default: 'Par d\u00e9faut',
  Circle: 'Cercle',
  Disc: 'Disque',
  Square: 'Carr\u00e9',
  'Lower Alpha': 'Alpha minuscule',
  'Lower Greek': 'Grec minuscule',
  'Lower Roman': 'Romain minuscule',
  'Upper Alpha': 'Alpha majuscule',
  'Upper Roman': 'Romain majuscule',
  Anchor: 'Ancre',
  Name: 'Nom',
  Id: 'Id',
  'Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.':
    "L'Id doit commencer par une lettre suivi par des lettres, nombres, tirets, points, deux-points ou underscores",
  'You have unsaved changes are you sure you want to navigate away?':
    'Vous avez des modifications non enregistr\u00e9es, \u00eates-vous s\u00fbr de quitter la page?',
  'Restore last draft': 'Restaurer le dernier brouillon',
  'Special character': 'Caract\u00e8res sp\u00e9ciaux',
  'Source code': 'Code source',
  'Insert/Edit code sample': 'Ins\u00e9rer / modifier une exemple de code',
  Language: 'Langue',
  'Code sample': 'Extrait de code',
  Color: 'Couleur',
  R: 'R',
  G: 'V',
  B: 'B',
  'Left to right': 'Gauche \u00e0 droite',
  'Right to left': 'Droite \u00e0 gauche',
  Emoticons: 'Emotic\u00f4nes',
  'Document properties': 'Propri\u00e9t\u00e9 du document',
  Title: 'Titre',
  Keywords: 'Mots-cl\u00e9s',
  Description: 'Description',
  Robots: 'Robots',
  Author: 'Auteur',
  Encoding: 'Encodage',
  Fullscreen: 'Plein \u00e9cran',
  Action: 'Action',
  Shortcut: 'Raccourci',
  Help: 'Aide',
  Address: 'Adresse',
  'Focus to menubar': 'Cibler la barre de menu',
  'Focus to toolbar': "Cibler la barre d'outils",
  'Focus to element path': "Cibler le chemin vers l'\u00e9l\u00e9ment",
  'Focus to contextual toolbar': "Cibler la barre d'outils contextuelle",
  'Insert link (if link plugin activated)': 'Ins\u00e9rer un lien (si le module link est activ\u00e9)',
  'Save (if save plugin activated)': 'Enregistrer (si le module save est activ\u00e9)',
  'Find (if searchreplace plugin activated)': 'Rechercher (si le module searchreplace est activ\u00e9)',
  'Plugins installed ({0}):': 'Modules install\u00e9s ({0}) : ',
  'Premium plugins:': 'Modules premium :',
  'Learn more...': 'En savoir plus...',
  'You are using {0}': 'Vous utilisez {0}',
  Plugins: 'Plugins',
  'Handy Shortcuts': 'Raccourcis utiles',
  'Horizontal line': 'Ligne horizontale',
  'Insert/edit image': 'Ins\u00e9rer/modifier une image',
  'Image description': "Description de l'image",
  Source: 'Source',
  Dimensions: 'Dimensions',
  'Constrain proportions': 'Conserver les proportions',
  General: 'G\u00e9n\u00e9ral',
  Advanced: 'Avanc\u00e9',
  Style: 'Style',
  'Vertical space': 'Espacement vertical',
  'Horizontal space': 'Espacement horizontal',
  Border: 'Bordure',
  'Insert image': 'Ins\u00e9rer une image',
  Image: 'Image',
  'Image list': "Liste d'images",
  'Rotate counterclockwise': 'Rotation anti-horaire',
  'Rotate clockwise': 'Rotation horaire',
  'Flip vertically': 'Retournement vertical',
  'Flip horizontally': 'Retournement horizontal',
  'Edit image': "Modifier l'image",
  'Image options': "Options de l'image",
  'Zoom in': 'Zoomer',
  'Zoom out': 'D\u00e9zoomer',
  Crop: 'Rogner',
  Resize: 'Redimensionner',
  Orientation: 'Orientation',
  Brightness: 'Luminosit\u00e9',
  Sharpen: 'Affiner',
  Contrast: 'Contraste',
  'Color levels': 'Niveaux de couleur',
  Gamma: 'Gamma',
  Invert: 'Inverser',
  Apply: 'Appliquer',
  Back: 'Retour',
  'Insert date/time': 'Ins\u00e9rer date/heure',
  'Date/time': 'Date/heure',
  'Insert link': 'Ins\u00e9rer un lien',
  'Insert/edit link': 'Ins\u00e9rer/modifier un lien',
  'Text to display': 'Texte \u00e0 afficher',
  Url: 'Url',
  Target: 'Cible',
  None: 'n/a',
  'New window': 'Nouvelle fen\u00eatre',
  'Remove link': 'Enlever le lien',
  Anchors: 'Ancres',
  Link: 'Lien',
  'Paste or type a link': 'Coller ou taper un lien',
  'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?':
    "L'URL que vous avez entr\u00e9e semble \u00eatre une adresse e-mail. Voulez-vous ajouter le pr\u00e9fixe mailto: n\u00e9cessaire?",
  'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?':
    "L'URL que vous avez entr\u00e9e semble \u00eatre un lien externe. Voulez-vous ajouter le pr\u00e9fixe http:// n\u00e9cessaire?",
  'Link list': 'Liste de liens',
  'Insert video': 'Ins\u00e9rer une vid\u00e9o',
  'Insert/edit video': 'Ins\u00e9rer/modifier une vid\u00e9o',
  'Insert/edit media': 'Ins\u00e9rer/modifier un m\u00e9dia',
  'Alternative source': 'Source alternative',
  Poster: 'Publier',
  'Paste your embed code below:': "Collez votre code d'int\u00e9gration ci-dessous :",
  Embed: 'Int\u00e9grer',
  Media: 'M\u00e9dia',
  'Nonbreaking space': 'Espace ins\u00e9cable',
  'Page break': 'Saut de page',
  'Paste as text': 'Coller comme texte',
  Preview: 'Pr\u00e9visualiser',
  Print: 'Imprimer',
  Save: 'Enregistrer',
  Find: 'Chercher',
  'Replace with': 'Remplacer par',
  Replace: 'Remplacer',
  'Replace all': 'Tout remplacer',
  Prev: 'Pr\u00e9c ',
  Next: 'Suiv',
  'Find and replace': 'Trouver et remplacer',
  'Could not find the specified string.': 'Impossible de trouver la cha\u00eene sp\u00e9cifi\u00e9e.',
  'Match case': 'Respecter la casse',
  'Whole words': 'Mots entiers',
  Spellcheck: 'V\u00e9rification orthographique',
  Ignore: 'Ignorer',
  'Ignore all': 'Tout ignorer',
  Finish: 'Finie',
  'Add to Dictionary': 'Ajouter au dictionnaire',
  'Insert table': 'Ins\u00e9rer un tableau',
  'Table properties': 'Propri\u00e9t\u00e9s du tableau',
  'Delete table': 'Supprimer le tableau',
  Cell: 'Cellule',
  Row: 'Ligne',
  Column: 'Colonne',
  'Cell properties': 'Propri\u00e9t\u00e9s de la cellule',
  'Merge cells': 'Fusionner les cellules',
  'Split cell': 'Diviser la cellule',
  'Insert row before': 'Ins\u00e9rer une ligne avant',
  'Insert row after': 'Ins\u00e9rer une ligne apr\u00e8s',
  'Delete row': 'Effacer la ligne',
  'Row properties': 'Propri\u00e9t\u00e9s de la ligne',
  'Cut row': 'Couper la ligne',
  'Copy row': 'Copier la ligne',
  'Paste row before': 'Coller la ligne avant',
  'Paste row after': 'Coller la ligne apr\u00e8s',
  'Insert column before': 'Ins\u00e9rer une colonne avant',
  'Insert column after': 'Ins\u00e9rer une colonne apr\u00e8s',
  'Delete column': 'Effacer la colonne',
  Cols: 'Colonnes',
  Rows: 'Lignes',
  Width: 'Largeur',
  Height: 'Hauteur',
  'Cell spacing': 'Espacement inter-cellulles',
  'Cell padding': 'Espacement interne cellule',
  Caption: 'Titre',
  Left: 'Gauche',
  Center: 'Centr\u00e9',
  Right: 'Droite',
  'Cell type': 'Type de cellule',
  Scope: 'Etendue',
  Alignment: 'Alignement',
  'H Align': 'Alignement H',
  'V Align': 'Alignement V',
  Top: 'Haut',
  Middle: 'Milieu',
  Bottom: 'Bas',
  'Header cell': "Cellule d'en-t\u00eate",
  'Row group': 'Groupe de lignes',
  'Column group': 'Groupe de colonnes',
  'Row type': 'Type de ligne',
  Header: 'En-t\u00eate',
  Body: 'Corps',
  Footer: 'Pied',
  'Border color': 'Couleur de la bordure',
  'Insert template': 'Ajouter un th\u00e8me',
  Templates: 'Th\u00e8mes',
  Template: 'Mod\u00e8le',
  'Text color': 'Couleur du texte',
  'Background color': "Couleur d'arri\u00e8re-plan",
  'Custom...': 'Personnalis\u00e9...',
  'Custom color': 'Couleur personnalis\u00e9e',
  'No color': 'Aucune couleur',
  'Table of Contents': 'Table des mati\u00e8res',
  'Show blocks': 'Afficher les blocs',
  'Show invisible characters': 'Afficher les caract\u00e8res invisibles',
  'Words: {0}': 'Mots : {0}',
  '{0} words': '{0} mots',
  File: 'Fichier',
  Edit: 'Editer',
  Insert: 'Ins\u00e9rer',
  View: 'Voir',
  Format: 'Format',
  Table: 'Tableau',
  Tools: 'Outils',
  'Powered by {0}': 'Propuls\u00e9 par {0}',
  'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help':
    "Zone Texte Riche. Appuyer sur ALT-F9 pour le menu. Appuyer sur ALT-F10 pour la barre d'outils. Appuyer sur ALT-0 pour de l'aide.",
});
